import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/elastomeric-coatings.html")({
  beforeLoad: () => { throw redirect({ to: "/foam-roof-coating-recoating", statusCode: 301 }); },
});
